import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * On phones the donation form sits below the story, so a slim bar at the
 * bottom of the screen leads to it. It hides once the form (#donate) is
 * on screen, and on wide screens where the form is always beside you.
 */
export default function StickyDonateBar({ label, targetId = "donate" }) {
  const [targetVisible, setTargetVisible] = useState(true);

  useEffect(() => {
    const target = document.getElementById(targetId);
    if (!target || typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(([entry]) => setTargetVisible(entry.isIntersecting), { rootMargin: "0px 0px -20% 0px" });
    observer.observe(target);
    return () => observer.disconnect();
  }, [targetId]);

  if (targetVisible) return null;

  const scrollToForm = () => {
    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    document.getElementById(targetId)?.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card/95 p-3 backdrop-blur-sm lg:hidden">
      <Button size="lg" className="w-full" onClick={scrollToForm}>
        <Heart className="h-4 w-4" /> {label}
      </Button>
    </div>
  );
}
